module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module-brand-mid"
  }, [_c('ad-list', {
    attrs: {
      "data": _vm.qyMiddleUpAdv.advList,
      "size": _vm.qyMiddleUpAdv.adDetails
    }
  }), _vm._v(" "), _c('ad-list', {
    attrs: {
      "data": _vm.qyMiddleMiddleAdv.advList,
      "size": _vm.qyMiddleMiddleAdv.adDetails
    }
  }), _vm._v(" "), _c('ad-list', {
    attrs: {
      "data": _vm.qyMiddleDownAdv.advList,
      "size": _vm.qyMiddleDownAdv.adDetails
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed714a76"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/brand/middle-ad/index.vue
// module id = 1675
// module chunks = 1